module.exports = __webpack_public_path__ + "img/sunset.9c314a2b.svg";